import React, { createContext, ReactNode, useState, useCallback } from 'react';
import { Icons } from 'components/commercetools-ui/types';

interface IconsContextType {
  icons: (Icons | null)[];
  shouldShowIcons: boolean;
  setIconsData: (icons: (Icons | null)[], shouldShowIcons: boolean) => void;
}

const initialIconsState: IconsContextType = {
  icons: [],
  shouldShowIcons: false,
  setIconsData: () => {},
};

export const IconsContext = createContext(initialIconsState);

interface IconsProviderProps {
  children: ReactNode;
}

export const IconsProvider: React.FC<IconsProviderProps> = ({ children }) => {
  const [icons, setIcons] = useState<(Icons | null)[]>([]);
  const [shouldShowIcons, setShouldShowIcons] = useState(false);

  const setIconsData = useCallback((newIcons: (Icons | null)[], newShouldShowIcons: boolean) => {
    setIcons(newIcons);
    setShouldShowIcons(newShouldShowIcons);
  }, []);

  return <IconsContext.Provider value={{ icons, shouldShowIcons, setIconsData }}>{children}</IconsContext.Provider>;
};
